import * as actionTypes from "../actions/actionTypes/documentRightsActionTypes";
import { USER_RIGHTS_CHANGED } from "../actions/eventTypes/index";
import initialState from "./initialState";

const documentRightsReducer = (state = initialState.documentRights, action) => {
  switch (action.type) {
    case actionTypes.LOAD_DOCUMENT_RIGHTS_SUCCESS: {
      return {
        ...state,
        [action.payload.stateKey]: { ...action.payload.rights, isLoaded: true }
      };
    }

    case USER_RIGHTS_CHANGED: {
      return {
        ...initialState.documentRights
      };
    }

    default: {
      return state;
    }
  }
};

export default documentRightsReducer;
